<style lang="stylus">
    .collapsemenu
        width 104px
        height 100%
        border-right 1px solid rgba(0, 0, 0, 0.06)
    .lv1-item
        position relative
        .lv1-menu
            width 100%
            position relative
            cursor pointer
            .lv1-item-icon
                position absolute
                left 24px
                top 8px
                pointer-events none
            .lv1-item-polygon
                position absolute
                right 10px
                top 6px
                width 16px
                height 16px
                pointer-events none
                transform rotate(-90deg)
                svg
                    position absolute
                    width 16px
                    height 16px
                    stroke: var(--svg-color-primary)
                &.active
                    transform rotate(0)
            .lv1-item-text
                padding-left 12px
                max-width 170px
                height 28px
                line-height 28px
                color var(--text-color-primary)
                font-size 12px

        .lv2-box
            .lv2-item
                cursor pointer
                .lv2-item-text
                    padding-left 12px
                    height 28px
                    line-height 28px
                    font-size 12px
                    color var(--text-color-primary-rgb-70)
                    &:hover
                        background-color var(--color-black-4)
                    &.active
                        background-color var(--color-black-6)
</style>

<template>
    <div class="collapsemenu">
        <div class="lv1-item" v-for="(lv1, index) in list" :key="index">
            <div class="lv1-menu" @click="clickLv1(lv1)">
                <p class="lv1-item-text text-ellipsis" :class="{ active: activeLv1ID == lv1.id }">
                    {{ lv1.name }}
                </p>
                <div class="lv1-item-polygon" :class="{ active: expandLvID.includes(lv1.id) }">
                    <svg viewBox="0 0 16 16" fill="none">
                        <path d="M11.75 6.25L8.25 9.75L4.75 6.25" stroke="inherit" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </div>
            </div>
            <collapseTransition>
                <ul class="lv2-box" v-if="expandLvID.includes(lv1.id)">
                    <li class="lv2-item" v-for="(lv2, index) in lv1.children" :key="index">
                        <p
                            class="lv2-item-text text-ellipsis"
                            :class="{ active: activeLv1ID == lv1.id && activeLv2ID == lv2.id }"
                            @click="clickLv2(lv1, lv2)"
                        >
                            {{ lv2.name }}
                        </p>
                    </li>
                </ul>
            </collapseTransition>
        </div>
    </div>
</template>

<script>
    import collapseTransition from "@/public/utils/collapse-transition.js";
    export default {
        name: "",
        components: {
            collapseTransition,
        },
        props: ["list", ""],
        data() {
            return {
                expandLvID: [],
                activeLv1ID: -1,
                activeLv2ID: -1,
            };
        },
        computed: {},
        methods: {
            clickLv1(lv1) {
                let index = this.expandLvID.indexOf(lv1.id);
                if (index == -1) {
                    this.expandLvID.push(lv1.id);
                } else {
                    this.expandLvID.splice(index, 1);
                }
            },
            clickLv2(lv1, lv2) {
                this.activeLv1ID = lv1.id;
                this.activeLv2ID = lv2.id;
                this.$emit("clickName", lv2.name);
            },
        },
        mounted() {
            this.expandLvID.push(0);
            this.activeLv1ID = 0;
            this.activeLv2ID = 0;
            this.$emit("clickName", "单位换算");
        },
    };
</script>
